import { FormControl, TextField } from "@mui/material";

const MDTextInput = ({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  error = false,
  helperText = "",
  fullWidth = false,
  disabled = false,
  sx = {},
  multiline = false,
  rows = 3,
  ...otherProps
}) => {
  return (
    <FormControl variant="outlined" fullWidth>
      <TextField
        label={label}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        fullWidth={fullWidth}
        disabled={disabled}
        variant="outlined"
        multiline={multiline}
        rows={multiline ? rows : undefined}
        sx={{
          fontFamily: "Inter, sans-serif",
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
          "& .MuiOutlinedInput-input": {
            padding: multiline ? "0px" : "16px 14px",
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
          },
          "& .MuiInputLabel-root": {
            fontFamily: "Inter, sans-serif",
          },
          "& .MuiFormHelperText-root": {
            minHeight: "20px",
            fontFamily: "Inter, sans-serif",
          },
          ...sx,
        }}
        {...otherProps}
      />
    </FormControl>
  );
};

export default MDTextInput;
